/**
 * WordPress dependencies
 */
import { getPhrasingContentSchema } from '@wordpress/blocks';
var transforms = {
  from: [{
    type: 'raw',
    isMatch: function isMatch(node) {
      return node.nodeName === 'FIGURE' && !!node.querySelector('iframe');
    },
    schema: {
      figure: {
        require: ['iframe'],
        children: {
          iframe: {
            attributes: ['src', 'allowfullscreen', 'height', 'width']
          },
          figcaption: {
            children: getPhrasingContentSchema()
          }
        }
      }
    }
  }]
};
export default transforms;
//# sourceMappingURL=transforms.js.map